import React, { useState, useEffect } from "react";
import Modal from "../../../component/Global/Modal";
import useReduxState from "../../../hooks/useReduxState";
import store from "src/storeWire";
import { SET_ADD_CART_DATA } from "src/store/slice/model/Cart";
import { useCartStore } from "src/hooks/cart";
import { useProductInventoryStore } from "src/hooks/productInventory";
import { useDOMAttachToSystemStore } from "src/hooks/domAttachToSystem";
// import Constants from "src/support/Constants";
import NavigateToPDP from "src/component/Global/Product/NavigateToPDP";
import DisplayLongDescriptionAndVariantMFRName from "src/component/Product/DisplayLongDescriptionAndVariantMFRName";

const InventoryAlertForAddToCartPopup = (props) => {
  const [status, SetStatus] = useState(false);
  const [, setProductSelected] = useReduxState({}, "setAutoCompleteProductSelected");
  const [searchTerm, setSearchTerm] = useReduxState("", "setAutoCompleteSearchTerm");
  const [{ InventoryAlertForAddToCartPopup }, { }, { }] = useDOMAttachToSystemStore();
  const [, { get_inventory_by_id }, { }] = useProductInventoryStore();
  const [{ }, { }, { ADD_TO_CART }] = useCartStore();
  const [load, SetLoad] = useState(false);
  const { single_product, cartRes, addToCartParam, isFrom, isManuallyAddCart } = InventoryAlertForAddToCartPopup.data


  useEffect(() => {
    if (InventoryAlertForAddToCartPopup) {
      SetStatus(true);
    }
  }, [InventoryAlertForAddToCartPopup]);

  const onHide = (action = true) => {
    SetStatus(false);
    if (action) {
      store.dispatch(SET_ADD_CART_DATA(false));
    }
  };

  const getProductInventoryQuantityByERPPartNumber = (ERPPartNumber) => {
    let inventoryResult = getInventory(ERPPartNumber);
    if (inventoryResult &&
      inventoryResult.quantity !== undefined &&
      inventoryResult.quantity > 0) {
      return inventoryResult.quantity;
    }
    return 0;
  };

  const getProductInventoryLeadTimeByERPPartNumber = (ERPPartNumber) => {
    if (ERPPartNumber === undefined || ERPPartNumber === null || ERPPartNumber === "") {
      return "";
    }
    let inventoryResult = getInventory(ERPPartNumber);
    if (inventoryResult && inventoryResult.plifz) {
      return inventoryResult.plifz;
    }
    return "Not Available";
  };

  //added by Ramya [Adobe script]
  const getInventory = (ERPPartNumber) => {
    return get_inventory_by_id(ERPPartNumber)
  };


  const onSubmit = async (e) => {
    if (load) {
      e.preventDefault();
      return false;
    }
    SetLoad(true);

    // if (props.data.isReplaceCart) {
    //   await replace_cart_in_Bulk(v);
    // } else {
    const payload = {
      ...addToCartParam,
      'isBackOrder': true,
      backOrderedQuantity: cartRes.backOrderedQuantity
    }

    const res = await ADD_TO_CART(payload, isFrom, single_product, isManuallyAddCart);

    // await new CartRepository().addToCartServer(param, props.data.isManuallyAddCart, props.data?.isFrom);
    // if (props.data.productAddedToCartCallback) {
    //   props.data.productAddedToCartCallback();
    // }

    if (isFrom && window?.digitalData) {
      if (!window?.digitalData?.transaction) {
        window.digitalData.transaction = {};
      }
      window.digitalData.event.eventinfo.events = "Add to Cart clicked from " + isFrom;
      window.digitalData.transaction.items = v?.ERPMFRPartNumber;
    }

    // }

    setProductSelected({});
    setSearchTerm("");
    SetLoad(false);
    SetStatus(false);

  }

  return (
    <>
      <Modal show={status} onHide={() => { onHide(); }}      >
        <div className="avnet-modal modal-680">
          <div className="avnet-modal-inner">
            {/* Modal Header */}
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              onClick={() => {
                onHide();
              }}
            >
              ×
            </button>
            <div className="modal-header justify-content-center mt-0">
              <h3 className="pcn-modal-heading">Inventory Alert</h3>
            </div>
            <div className="m-4 mt-0">
              <div className="justify-content-start">
                We currently do not have sufficient inventory for the following
                items in your cart. <br />
                Would you like to place backorder for these items?
              </div>
            </div>
            <div className="modal-body">
              <div className="inventory-table">
                <table className="table table-outline rounded-0">
                  <thead className="bg-light">
                    <tr>
                      <th className="border-0 text-none font-12">Product(s)</th>
                      <th className="border-0 text-none font-12">Requested Quantity</th>
                      <th className="border-0 text-none font-12">Backorder Quantity</th>
                    </tr>
                  </thead>
                  <tbody className="border-top-0">
                    <tr>
                      <td className="align-middle">
                        <div className="inventory-product-info">
                          <div className="inventory-product-name">
                            <NavigateToPDP data={{
                              ManufacturerName: addToCartParam.ManufacturerName,
                              ERPMFRPartNumber: addToCartParam.ERPMFRPartNumber,
                              ItemNumber: addToCartParam.ItemNumber,
                            }}>
                              <b className='text-black'>{addToCartParam.ERPMFRPartNumber}</b>
                            </NavigateToPDP>
                          </div>
                          <div className="inventory-product-by">
                            <DisplayLongDescriptionAndVariantMFRName
                              currentProduct={single_product} inventory_alert_popup={true} />
                          </div>
                          <div className="inventory-product-stock"><b>In
                            Stock: {getProductInventoryQuantityByERPPartNumber(cartRes.ERPPartNumber || cartRes.partNumber)}</b>
                          </div>
                          <div className="inventory-product-lead">Lead Time From
                            Supplier: {getProductInventoryLeadTimeByERPPartNumber(cartRes.ERPPartNumber || cartRes.partNumber)}
                          </div>
                        </div>
                      </td>
                      <td className="align-middle">
                        <span>{addToCartParam.quantity}</span>
                      </td>
                      <td className="align-middle">
                        <span>{cartRes.backOrderedQuantity}</span>

                      </td>
                    </tr>


                  </tbody>
                </table>
              </div>
            </div>
            {/* Modal footer */}
            <div className="modal-footer justify-content-center">
              <div className="modal-footer-actions">
                <button type="button" className="bs5 btn btn-secondary btn-sm w145" disabled={load} data-bs-toggle="modal" data-bs-target="#InventoryModal"
                  onClick={() => { onHide(); }}                >
                  No
                </button>
                <button type="button" className="bs5 btn btn-primary btn-sm w145"
                  onClick={onSubmit}
                >

                  {load ? <i className="fa fa-spinner fa-spin" /> : <>Yes</>}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default InventoryAlertForAddToCartPopup;
